// extracted by mini-css-extract-plugin
export default {"btn":"modal_frs_btn__lMIdA","rightTextElem":"modal_frs_rightTextElem__7fnGo"};